export enum EDesktopListingView {
  VISIBLE = 'visible',
  HIDDEN = 'hidden',
}

export interface IDesktopListingState {
  view: EDesktopListingView;
}
